export default function OfficeIcon() {
  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="23" cy="23" r="23" fill="#F0F3F9" />
      <path
        d="M12.5 31.2484H33.5M31.9995 31.2484V20.7484C31.9995 20.5495 31.9204 20.3587 31.7798 20.2181C31.6391 20.0774 31.4484 19.9984 31.2495 19.9984H24.4995M27.4995 27.4984H28.9995M24.4995 31.2484V14.7484C24.4995 14.5495 24.4204 14.3587 24.2798 14.2181C24.1391 14.0774 23.9484 13.9984 23.7495 13.9984H14.7495C14.5505 13.9984 14.3598 14.0774 14.2191 14.2181C14.0785 14.3587 13.9995 14.5495 13.9995 14.7484V31.2484M16.9995 27.4984H19.9995M27.4995 23.7484H28.9995M18.4995 23.7484H21.4995M16.9995 17.7484H19.9995"
        stroke="#8897AE"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
